import React from 'react';
import classNames from 'classnames';

import Checkbox from '../../checkbox';

const CheckboxCell = ({
  onSelect,
  checked,
  color,
  stopPropagation = false,
  lastRow = false,
  showDeselect = false,
  hidden = false,
}: {
  onSelect: any;
  checked: boolean;
  color?: string;
  stopPropagation?: boolean;
  lastRow?: boolean;
  showDeselect?: boolean;
  hidden?: boolean;
}) => {
  return (
    <td
      className={classNames(
        'sticky px-4 left-0 flex flex-none items-center h-full border-neutral-gray-300 box-border w-12 bg-inherit',
        lastRow ? 'border-0' : 'border-b',
      )}
    >
      {hidden ? null : (
        <Checkbox
          checked={checked}
          color={color}
          onSelect={onSelect}
          stopPropagation={stopPropagation}
          showDeselect={showDeselect}
        />
      )}
    </td>
  );
};

export default CheckboxCell;
